// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@sc/XDL/Icons/Close";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "common.ui9",
        typographyProps: {
            size: 12,
            color: "common.white",
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
                margin: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                order: 2;
            `,
        },
        iconProps: {
            size: 6,
            src: Close,
            color: "common.ui1",
        },
        css: css`
            border-radius: 12px;
            padding: 6px 8px;
            min-height: initial;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            margin-bottom: 0;
            display: flex;
            align-items: baseline;
            gap: 8px;
            &&& > ${ButtonWrapper} {
                min-height: initial;
                background: transparent;
                margin-top: 3px;
            }
            button {
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui8")};
                    }
                }
            }
        `,
    },
} as xBaseTheme["tag"];
